import * as z from "zod";

export type AwaitedLinearEvent = z.infer<typeof AwaitedLinearEvent>;
export const AwaitedLinearEvent = z.object({
  id: z.string(),
  identifier: z.string(),
  url: z.string(),
});

export const SessionLinearEvents = z.object({
  awaited_linear_events: z.array(AwaitedLinearEvent).optional(),
});

export const SessionListLinearEvents = z.object({
  sessions: z.array(SessionLinearEvents),
});
